export const camelToKebab = (str: string) => str.replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`)
